import React, { Component } from 'react';
import { getDownloadedFile, showErrorInNotification, copyStringToClipboard, formatMoney, blobToFile } from '../lib/util';
import { message, Spin, notification, Result, Menu, Empty, Dropdown } from 'antd';
import { Column, Table, AutoSizer, CellMeasurer, CellMeasurerCache, List } from 'react-virtualized';
import 'react-virtualized/styles.css';
import XLSX from 'xlsx';
import lodash from 'lodash';
import ReactDataGrid, { Row } from 'react-data-grid';
import 'react-data-grid/dist/react-data-grid.css'
import JsonBlockCard from './json_block_card';
import { COLORS } from '../pages/theme';
import { PDFViewer } from './pdf_viewer';
// import { Menu } from "react-data-grid-addons";
// import { func } from 'prop-types';

// const { ContextMenu, MenuItem, SubMenu, ContextMenuTrigger } = Menu;

const READ_AS_TEXT = ['json', 'jrn'];
const EXCEL_FORMAT = ['EXCEL', "CSV"];
const PDF_FORMAT = ['PDF'];

const READ_AS_OTHER = [...EXCEL_FORMAT, ...PDF_FORMAT]

// function ExampleContextMenu({
//   idx,
//   id,
//   rowIdx,
//   onRowDelete,
//   onRowInsertAbove,
//   onRowInsertBelow
// }) {
//   return (
//     <ContextMenu id={id}>
//       <MenuItem data={{ rowIdx, idx }} onClick={onRowDelete}>
//         Delete Row
//       </MenuItem>
//       {/* <SubMenu title="Insert Row">
//         <MenuItem data={{ rowIdx, idx }} onClick={onRowInsertAbove}>
//           Above
//         </MenuItem>
//         <MenuItem data={{ rowIdx, idx }} onClick={onRowInsertBelow}>
//           Below
//         </MenuItem>
//       </SubMenu> */}
//     </ContextMenu>
//   );
// }

const LabelFilter = ({ type = 'default', label, count, onClick }) => {
  return <div onClick={onClick}
    className='hand-cursor' style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginRight: 60
    }}>
    {/* <div className={`${type}-label-box`} style={{
        height:20,width:20,
        borderRadius:4
      }}></div> */}
    <span className='sub-heading-3' style={{
      color: COLORS.secondary
    }}>{label}</span>
    <span className={`heading-2 ${type}-label`} style={{

    }}>{formatMoney(count, 0)}</span>
  </div>
}

const EmptyRowView = () => {
  return <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      minHeight: 400,
      alignItems: 'center'
    }}
  ><Empty /></div>
}

let block_to_highlight = [
]

let json_block_to_highlight = [
  { "__uri__": "/home/ntvirus/Codes/work/cli/SCBINR/Our Book Balance.xlsx", "closing_balance": 0, "cr_amount": "10000.0", "dr_amount": "0", "match_reference": "23BANKRTGS18347", "opening_balance": 0, "ref_num": "", "tran_date": "2020-03-26", "tran_id": "", "tran_particular": "23BANKRTGS18347", "tran_remarks": "", "value_date": "2020-03-26" }
]

function get_header_row(sheet) {
  var headers = [
    {
      key: '_SN',
      name: "SN",
      resizable: true,
      formatter: ({ column = {}, row = {}, rowIdx }) => {
        console.log("formated value", rowIdx)
        return <div title={rowIdx + 1}>{rowIdx + 1}</div>
      }
    }
  ];
  var range = XLSX.utils.decode_range(sheet['!ref']);
  var C, R = range.s.r; /* start in the first row */
  /* walk every column in the range */
  for (C = range.s.c; C <= range.e.c; ++C) {
    //   var cell = sheet[XLSX.utils.encode_cell({c:C, r:R})] /* find the cell in the first row */
    // console.log("range",C)
    var hdr = String.fromCharCode(65 + C) // <-- replace with your desired default 
    // if(cell && cell.t) hdr = XLSX.utils.format_cell(cell);

    headers.push({
      key: C,
      name: hdr,
      resizable: true,
      formatter: ({ column = {}, row = {} }) => {
        console.log("formatted", row, column);
        return <Dropdown overlay={<Menu>
          <Menu.Item key="1" onClick={() => {
            copyStringToClipboard(row[column.key]);
            message.success("Cell Value Copied");
          }}>Copy Cell Item</Menu.Item>
          <Menu.Item key="2" onClick={() => {
            copyStringToClipboard(JSON.stringify(row));
            message.success("Row Copied");
          }}>Copy Whole Row</Menu.Item>
        </Menu>} trigger={['click', 'contextMenu']}><div title={row[column.key]}>{row[column.key]}</div></Dropdown>
      }
    });
  }
  return headers;
}

let excel_errorblock_to_highlight = [3]

let excel_parsedblock_to_highlight = []

// const RowRenderer = ({ renderBaseRow, ...props }) => {
//   console.log("render log row",renderBaseRow,props)
//   const color = props.idx % 2 ? "green" : "blue";
//   return <Row {...props} />;
// };

class DebugFilePreview extends Component {
  constructor(props) {
    super(props)

    this.state = {
      text: "",
      downloadedFile: null,
      original_text: "",
      highlighter: [],
      columns: [],
      rows: [],
      rows_bk: [],
      loading: true,
      highlighted: false,
      error: false,
      extension: null,
      error_object: {},
      success_index: [],
      error_index: [],
      json_array: [],
      json_array_bk: [],
      current_showing: null
    }
    this.cache = new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 100
    });

    this._rowRenderer = this._rowRenderer.bind(this);
  }






  highlight_file = (markers = []) => {

    if (this.state.highlighted || this.state.loading) {
      console.log("already highlighted")
      return;
    }
    let text = this.state.text || "";
    let textArr = text.split("");
    let assign_index = 0;

    markers.sort((a, b) => a.start - b.start)

    markers.map((marker, index) => {
      let className = index % 2 ? 'success_row' : 'success_row_2';
      if (marker.error) {
        className = index % 2 ? 'error_row' : 'error_row_2'
      }
      textArr.splice(marker.start + assign_index, 0, `<mark class=${className}>`);
      assign_index += 1;
      textArr.splice(marker.end + assign_index, 0, '</mark>');
      assign_index += 1;
    })

    this.setState({
      text: textArr.join(""),
      highlighted: markers.length > 0 ? true : false
    }, () => {
      this.renderPreview();
    })
  }



  highlight_json = (markers = [], jsonArray = []) => {
    if (this.state.highlighted || this.state.loading) {
      console.log("already highlighted")
      return;
    }

    // var allText = JSON.stringify(jsonArray);
    // var allTextArr = allText.split("");
    let cnt = 0;
    // allTextArr.map(() => {
    //   cnt += 1
    // });
    var allText = this.state.text;
    console.log("count lenght", cnt)
    markers.sort((a, b) => a.index - b.index)
    markers.map((marker, index) => {
      console.log("highlighting for", marker)
      try {
        // text = text.insert(marker.start, `<mark>`);
        // console.log("hahaha is", text)
        // text = text.insert(marker.end, "</mark>")
      } catch (e) {
        console.log("ERROR WHEN ADDING MARKER", e)
      }
      // console.log(`After highlight at ${index}`, text)
      // marker.start
    });
    this.setState({
      text: allText,
      highlighted: markers.length > 0 ? true : false
    }, () => {
      this.renderPreview()

    })

  }

  // readFile = (file, extension) => {
  //   // var rawFile = new XMLHttpRequest();
  //   console.log("file is", file)

  //   switch (extension) {
  //     case 'TXT':
  //       this.setState({
  //         text: file
  //       }, () => {
  //         this.renderPreview()
  //       });
  //       // this.highlight(this.props.highlighter,this.props.extension)
  //       break;
  //     case 'json':
  //       console.log("json found", typeof file, file);
  //       if (typeof file === 'object') {
  //         this.highlight_json(json_block_to_highlight, file);
  //       } else {
  //         throw new Error(`NOT FORMATTED JSON`)
  //       }
  //       break;

  //     default:
  //       throw new Error(`FILE PREVIEW NOT DEFINED FOR ${extension}`)
  //       break;
  //   }

  // };

  highlight = (highlighter = [], extension, file) => {
    highlighter.sort((a, b) => a.index - b.index)
    let success_highlight = lodash.filter(highlighter, ['error', false]);
    let error_highlight = lodash.filter(highlighter, ['error', true]);

    this.setState({ highlighter: highlighter })

    if (EXCEL_FORMAT.includes(extension) || extension == 'JSON') {
      console.log("highlighting for excel or json");
      let success_index = lodash.map(success_highlight, 'index');
      let error_index = lodash.map(error_highlight, 'index');
      console.log("success index", success_index);
      console.log("error index", error_index)
      this.setState({
        success_index, error_index
      })


    } else if (extension == 'JSON') {
      // this.highlight_json(highlighter)

    } else {
      this.highlight_file(highlighter)
    }
  }

  renderPreview = () => {
    let canvas = document.getElementById("debugger-preview");
    canvas.innerHTML = this.state.text
  }

  filterRowData = ({ indexes, current_showing, reverse }) => {
    if (indexes == null) {
      // back to old data
      this.setState({
        rows: JSON.parse(JSON.stringify(this.state.rows_bk)),
        current_showing: null
      })
    } else {
      let bk_data = JSON.parse(JSON.stringify(this.state.rows_bk));
      let pulled_data = lodash.pullAt(bk_data, indexes)
      this.setState({
        rows: reverse ? bk_data : pulled_data,
        current_showing: current_showing
      })
    }
  }

  filterJsonData = ({ indexes, current_showing, reverse }) => {
    if (indexes == null) {
      // back to old data
      this.setState({
        json_array: JSON.parse(JSON.stringify(this.state.json_array_bk)),
        current_showing: null
      })
    } else {
      let bk_data = JSON.parse(JSON.stringify(this.state.json_array_bk));
      let pulled_data = lodash.pullAt(bk_data, indexes)
      this.setState({
        json_array: reverse ? bk_data : pulled_data,
        current_showing: current_showing
      })
    }
  }





  _rowRenderer({ index, key, style, parent, isVisible }) {
    console.log("rendering index", index);
    let isError, isSuccess;
    if (this.state.current_showing == 'error') {
      isError = true;
    } else if (this.state.current_showing == 'success') {
      isSuccess = true;
    }
    else if (this.state.error_index.includes(index)) {
      isError = true;
    }
    else if (this.state.success_index.includes(index)) {
      isSuccess = true;
    }

    if (isVisible) return (
      <CellMeasurer
        key={key}
        cache={this.cache}
        parent={parent}
        columnIndex={0}
        rowIndex={index}>
        <div key={index} style={style}>
          <JsonBlockCard
            key={`${index}--`}
            index={index}
            data={this.state.json_array[index]}
            error={isError}
            success={isSuccess}
          />
        </div>
      </CellMeasurer>
    );
  }
  _cellRenderer({ columnIndex, key, rowIndex, style }) {
    return (

      <div
        key={key}
        style={style}
      >
        {/* <JsonBlockCard data={this.state.json_array[rowIndex]}
          /> */}
      </div>
    );
  }

  render() {
    const { markers, text, loading, extension, error_object, success_index, error_index } = this.state;

    return (
      <div>
        {loading && (this.props.highlighter_downloaded == false) && <center><Spin /></center>}

        {!loading && EXCEL_FORMAT.includes(extension) &&
          <div
            style={{
              height: 'calc(100vh - 100px)'
            }}>
            {this.props.hide_filter == true ? null :
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                height: 40,
                // justifyContent:'space-between'
              }}>
                <LabelFilter
                  label="Success Blocks"
                  count={success_index.length}
                  type='success'
                  onClick={() => {
                    this.filterRowData({
                      indexes: success_index,
                      current_showing: 'success'
                    })
                  }}
                />
                <LabelFilter
                  label="Error Blocks"
                  count={error_index.length}
                  type='danger'
                  onClick={() => {
                    this.filterRowData({
                      indexes: error_index,
                      current_showing: 'error'
                    })
                  }}
                />
                {/* <LabelFilter 
        label="Unparsed Blocks"
        count={(this.state.rows_bk.length-error_index.length-success_index.length)}
        type='default'
        onClick={()=>{
          this.filterRowData({
            indexes:[...error_index,...success_index],
            current_showing:'unparsed',
            reverse:true
          })
        }}
        /> */}
                <LabelFilter
                  label="All Blocks"
                  count={this.state.rows_bk.length}
                  type='primary'
                  onClick={() => {
                    this.filterRowData({
                      indexes: null,
                    })
                  }}
                />

              </div>}

            <div
              className='data-grid-wrapper'
              style={{
                height: this.props.hide_filter === true ? 'calc(100vh - 100px)' : 'calc(100vh - 140px)'
              }}>
              <AutoSizer>
                {({ height, width }) => (
                  <ReactDataGrid

                    rowGetter={i => this.state.rows[i]}
                    columns={this.state.columns}

                    // onRowClick={(rowIndex,row)=>{
                    //   copyStringToClipboard(JSON.stringify(row));
                    //   message.success("Row copied")
                    // }}
                    // valueRenderer={(cell) => cell}
                    rows={this.state.rows}
                    rowsCount={this.state.rows.length}
                    emptyRowsRenderer={EmptyRowView}
                    width={width}
                    height={height}
                    // contextMenu={
                    //   <ExampleContextMenu
                    //     onRowDelete={(e, { rowIdx }) => {}}
                    //     onRowInsertAbove={(e, { rowIdx }) => {}}
                    //     onRowInsertBelow={(e, { rowIdx }) => {}}
                    //   />
                    // }
                    // trigg={ContextMenuTrigger}
                    minHeight='calc(100vh - 100px)'
                    rowRenderer={(props) => {
                      console.log("custom renderer", props)
                      let className = 'virtual-row hand-cursor'
                      if (this.state.current_showing == 'error') {
                        className = className + ' error_row '
                      } else if (this.state.current_showing == 'success') {
                        className = className + ' success_row '
                      }
                      else if (error_index.includes(props.rowIdx)) {
                        className = className + ' error_row '
                      }
                      else if (success_index.includes(props.rowIdx)) {
                        className = className + ' success_row '
                      }
                      return <Row {...props}

                        className={className}
                      />;
                    }}
                  // enableCellAutoFocus={false}
                  />)}</AutoSizer>
            </div>
          </div>}
        {!loading && PDF_FORMAT.includes(extension) && <div>
          <PDFViewer file={this.state.downloadedFile} />
        </div>}

        {this.state.error && <Result
          status="warning"
          title={typeof error_object.error_message === 'string' ? error_object.error_message : "There was some error downloading file"}
        />}
        <pre style={{
          marginBottom: 0
        }} id='debugger-preview'></pre>
        {!loading && extension == 'JSON' &&
          <div
            style={{
              height: 'calc(100vh - 100px)'
            }}>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              height: 40,
              // justifyContent:'space-between'
            }}>
              <LabelFilter
                label="Success Blocks"
                count={success_index.length}
                type='success'
                onClick={() => {
                  this.filterJsonData({
                    indexes: success_index,
                    current_showing: 'success'
                  })
                }}
              />
              <LabelFilter
                label="Error Blocks"
                count={error_index.length}
                type='danger'
                onClick={() => {
                  this.filterJsonData({
                    indexes: error_index,
                    current_showing: 'error'
                  })
                }}
              />
              {/* <LabelFilter 
        label="Unparsed Blocks"
        count={(this.state.json_array_bk.length-error_index.length-success_index.length)}
        type='default'
        onClick={()=>{
          this.filterJsonData({
            indexes:[...error_index,...success_index],
            current_showing:'unparsed',
            reverse:true
          })
        }}
        /> */}
              <LabelFilter
                label="All Blocks"
                count={this.state.json_array_bk.length}
                type='primary'
                onClick={() => {
                  this.filterJsonData({
                    indexes: null,
                  })
                }}
              />

            </div>

            <div
              style={{
                height: 'calc(100vh - 140px)'
              }}>
              <AutoSizer>
                {({ height, width }) => (

                  <List
                    style={{
                      outline: 'none'
                    }}
                    noRowsRenderer={EmptyRowView}
                    width={width}
                    height={height}
                    rowCount={this.state.json_array.length}
                    rowHeight={this.cache.rowHeight}
                    rowRenderer={this._rowRenderer}
                    overscanRowCount={3}
                  />
                )}
              </AutoSizer>
            </div>
          </div>}
      </div>
    );
  }







  componentDidUpdate = (prevProps) => {
    if (this.props.url !== prevProps.url || this.props.extension !== prevProps.extension) {
      console.log("url or extension changed")
      this.downloadFile()
      // fetch the new product based and set it to the state of the component
    };

    console.log("comparing:", this.props.highlighter, prevProps.highlighter)
    if (!lodash.isEqual(this.props.highlighter, prevProps.highlighter)) {
      this.highlight(this.props.highlighter, this.props.extension);
    }
  }

  downloadFile = () => {
    if (this.props.url && this.props.extension) {
      this.setState({
        loading: true,
        error: false,
        extension: this.props.extension,
        error_object: {}
      })

      let as_text = false;
      if (READ_AS_OTHER.includes(this.props.extension)) {
        as_text = false
      }
      getDownloadedFile(this.props.url, as_text)
        .then((file) => {
          // console.log("got file", file);
          // this.handleSheetFile(file)
          let ctx = this;
          switch (this.props.extension) {
            case 'PDF':
              console.log(file);
              const pdfReader = new FileReader()
              pdfReader.onload = value => {
                console.log(value);
                ctx.setState({
                  downloadedFile: value.target.result,
                  loading: false
                });
                // resolve({ success: true, data: reader.result })
              }
              pdfReader.onError = error => {
                ctx.setState({
                  error: true,
                  loading: false,
                  error_object: {
                    error_message: error.toString()
                  }
                });
              }
              pdfReader.readAsDataURL(file)

              break;
            case 'EXCEL':
            case 'CSV':
              var reader = new FileReader();
              reader.onload = function (e) {
                var data = e.target.result;
                let readedData = XLSX.read(data, { type: ctx.props.extension == 'CSV' ? 'string' : 'binary', cellDates: true });
                const wsname = readedData.SheetNames[0];
                const ws = readedData.Sheets[wsname];
                // console.log("worksheet",ws);
                // var range = XLSX.utils.decode_range(ws['!ref']);
                // console.log("range",get_header_row(ws))

                /* Convert array to json*/
                const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1, dateNF: 'YYYY-MM-DD', raw: false, defval: "", range: 0 });

                console.log("parsed data", dataParse);
                let rows = dataParse || [];
                let cols = get_header_row(ws);
                // let header_row = (rows.splice(0, 1) || [])[0] || [];
                // header_row.map((item, index) => {
                //   cols.push({
                //     display_name: item,
                //     key: index
                //   })
                // })
                console.log("col", cols);
                // console.log("row", rows)
                ctx.setState({
                  columns: cols,
                  rows: rows,
                  rows_bk: JSON.parse(JSON.stringify(rows))
                }, () =>
                  ctx.setState({
                    loading: false
                  }));
                ctx.highlight(ctx.props.highlighter, ctx.props.extension)
              }

              // setFileUploaded(dataParse);
              reader.readAsBinaryString(file)
              break;

            case 'JSON':
              console.log("json found", typeof file, file);
              var json_reader = new FileReader();
              json_reader.onload = function (e) {
                console.log("file is", typeof e.target.result);
                try {
                  let parsed_json = JSON.parse(e.target.result);
                  console.log("parsed json", parsed_json)
                  ctx.setState({
                    json_array: parsed_json,
                    json_array_bk: JSON.parse(JSON.stringify(parsed_json))
                  }, () => {
                    ctx.setState({
                      loading: false
                    });
                    // ctx.highlight([], ctx.props.extension,parsed_json)
                  });
                } catch (e) {

                }
              }
              json_reader.readAsBinaryString(file)
              break;

            default:
              var txt_reader = new FileReader();
              txt_reader.onload = function (e) {
                console.log("file is", e.target.result)
                console.log("error section begin", e.target.result.substring(4702, 4720));
                ctx.setState({
                  loading: false,
                  original_text: e.target.result,
                  text: e.target.result
                }, () => {
                  ctx.highlight(ctx.props.highlighter, ctx.props.extension)
                });
              }
              txt_reader.readAsBinaryString(file)


              break;
          }

        }).catch((error) => {
          showErrorInNotification(error.response && error.response.data)
          this.setState({
            error: true,
            loading: false,
            extension: null,
            error_object: (error.response && error.response.data) || {
              error_message: "Error Downloading file"
            }
          })
          // console.log("there was error", error.response&&error.response.data)
        });
    } else {
      this.setState({
        loading: false, error: true, error_object: {
          error_message: "File url or extennsion missing"
        }
      })
    }
  }

  componentDidMount() {

    this.downloadFile();
    if (Array.isArray(this.props.highlighter) && this.props.highlighter.length > 0) {
      if (EXCEL_FORMAT.includes(this.props.extension) || this.props.extension == "JSON") {
        this.highlight(this.props.highlighter, this.props.extension)
      }
    }
    // this.readFile(require('./xls_test_1.xlsx'), 'xls')

  }
}

export default DebugFilePreview;